import { ChoiceGroup } from "@fluentui/react";
import React from "react";
import NextPreviousSection from "../NextPreviousSection.jsx/NextPreviousSection";
import { t } from "i18next";
import { ACTIONS } from "../../../../constants/Constants";
const PasswordProtectedSection = (props) =>{
    return (
<div className="tab-section">
                    <p
                      style={{
                        fontSize: "22px",
                        fontWeight: "600",
                        marginBottom: "30px",
                      }}
                    >
                     {t("hospital.password-protected-text")}
                    </p>
                    <div className="ms-Grid" dir="ltr">
                      <div className="ms-Grid-row">
                        <div className="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl3">
                        {(props.action === ACTIONS.ADD || props.action === ACTIONS.EDIT) && !props.editConfigurationSetting &&
                          <div>
                            <ChoiceGroup
                              styles={props.choiceGroupStyles}
                              value={props.values.password_protected}
                              defaultSelectedKey={props.values.password_protected}
                              options={props.passwordProtectedOptions}
                              onChange={(e, val) => {
                                props.values.password_protected = val.key;
                              }}
                            />
                          </div>
                        }
                        {(props.action === ACTIONS.VIEW  || props.editConfigurationSetting)  &&
                          <div>
                            {/* <ChoiceGroup
                              styles={props.choiceGroupStyles}
                              value={props.values.password_protected}
                              defaultSelectedKey={props.values.password_protected}
                              options={props.passwordProtectedOptions}
                            /> */}
                            <div className="form-mt-10">{props.values.password_protected ? "Yes" : "No"}</div>
                          </div>
                        }
                        </div>
                      </div>
                    </div>
         </div>
    )
}

export default PasswordProtectedSection;